import { Box, Card, CardActionArea, CardContent, Grid, SxProps, Theme, Typography } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { BRANDS } from 'shared/constants';
import { useTitle } from 'shared/hooks';
import { Brands } from 'shared/types';

const rootStyles: SxProps<Theme> = {
  height: 'calc(100vh - 175px)',
  overflow: 'auto',
};
const containerStyles: SxProps<Theme> = theme => ({
  marginTop: '100px',
  display: 'grid',
  gridTemplateColumns: 'repeat(4, 1fr)',
  gap: theme.spacing(2),
  padding: theme.spacing(1),
  [theme.breakpoints.down('lg')]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
  [theme.breakpoints.down('xs')]: {
    gridTemplateColumns: '1fr',
  },
});
const cardStyles: SxProps<Theme> = {
  height: '100%',
  minHeight: '',
};

interface BrandListProps {
  brands: Brands[];
}

export function BrandList({ brands }: BrandListProps) {
  const history = useHistory();
  useTitle('Multi-Brand CPQ Workflow - Brand List');

  return (
    <Box sx={rootStyles}>
      <Box sx={containerStyles}>
        {brands.length ? (
          brands.map(brand => (
            <Card key={brand} sx={cardStyles} elevation={2}>
              <CardActionArea sx={cardStyles} onClick={() => history.push(`quotes/${brand}`)}>
                {/* <CardMedia
                  component='img'
                  alt='Brand Logo'
                  title={BRANDS[brand]}
                  image={`/${brand}-logo.png`}
                /> */}
                <CardContent component={Grid} container direction='column' alignItems='center' spacing={2}>
                  <Grid item>
                    <Typography variant='h5'>{BRANDS[brand]}</Typography>
                  </Grid>
                  <Grid item>
                    <Grid container alignItems='center'>
                      <Grid item>
                        <Typography variant='button'>view quotes</Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </CardContent>
              </CardActionArea>
            </Card>
          ))
        ) : (
          <Grid item>
            <Typography>No brands are assigned to your account.</Typography>
          </Grid>
        )}
      </Box>
    </Box>
  );
}
